import React from 'react'

const Paragraph = ({data}) => {
    return <p className="commonParagraph">{data}</p>;
}

export default Paragraph